export class SettingsRoutesI18n {
    public static ManageUsers = 'Manage Users';
    public static NotificationPreferences = 'Notifications';
    public static Profile = 'My Profile';
    public static ResetPassword = 'Reset Password';
    public static MultiFactorAuthentication = 'Multi-Factor Authentication';
    public static Settings = 'Settings';
    public static PaymentMethods = 'Payment Methods';
    public static FAQ = 'Frequently Asked Questions';
    public static ScfBankAccounts = 'Payment Methods';
    public static ScfManageUsers = 'Manage Users';
}
